import { useMutation } from '@apollo/client'
import { EditGroup, EditGroupVariables } from '../../types'
import { EDIT_GROUP } from './operations'

export const useEditGroup = () => useMutation<EditGroup, EditGroupVariables>(EDIT_GROUP)
